import {
    Component,
    ElementRef,
    ViewEncapsulation,
    ChangeDetectionStrategy,
    inject,
    input,
    OnInit,
} from '@angular/core';

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(
    `:host { --width: initial; --margin-start: 0; --margin-end: 0; --margin-top: 0; --margin-bottom: 0; --border-width: initial; --border-style: initial; --color: initial; --size-point: initial; width: var(--width); margin-left: var(--margin-start); margin-right: var(--margin-end); margin-top: var(--margin-top); margin-bottom: var(--margin-bottom); color: var(--color); display: flex; align-items: center; } .bazis-trip-line__point { flex-shrink: 0; width: var(--size-point); height: var(--size-point); border-radius: 50%; background: var(--color); } .bazis-trip-line__point:first-child { left: 0; } .bazis-trip-line__point:last-child { right: 0; } .bazis-trip-line__line { width: 100%; margin: 0 3px; border-width: var(--border-width); border-style: var(--border-style); border-color: var(--color); } .bazis-trip-line__arrow { flex-shrink: 0; display: flex; align-items: center; margin: 0 3px; } .bazis-trip-line__arrow::before { content: ""; width: 12px; height: 0; border-width: var(--border-width); border-style: solid; border-color: var(--color); } .bazis-trip-line__sign { flex-shrink: 0; padding: 0 10px; border-radius: 16px; border-width: var(--border-width); border-style: solid; border-color: var(--color); font-weight: 700; font-size: 12px; line-height: 16px; }`,
);

@Component({
    selector: 'bazis-trip-line',
    templateUrl: './trip-line.component.html',
    // styleUrls: ['./trip-line.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TripLineElement implements OnInit {
    public el = inject(ElementRef);

    readonly hasArrow = input<boolean>(false);

    readonly hasPoints = input<boolean>(true);

    readonly onlyArrow = input<boolean>(false);

    readonly sign = input<string>('');

    ngOnInit(): void {
        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }
}
